import * as React from "react";

export function ProductHero({
  eyebrow,
  title,
  description,
}: {
  readonly eyebrow: React.ReactNode;
  readonly title: React.ReactNode;
  readonly description: React.ReactNode;
}) {
  const headingId = React.useId();

  return (
    <section
      className="flex min-h-80 items-center border-b border-brand bg-brand text-on-brand"
      aria-labelledby={headingId}
      data-product-hero
    >
      <div className="mx-auto w-full max-w-app px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-on-brand/70">
          {eyebrow}
        </p>
        <h1
          id={headingId}
          className="mt-3 max-w-6xl text-4xl font-bold tracking-[-0.045em] sm:text-6xl"
        >
          {title}
        </h1>
        <p className="mt-4 max-w-2xl text-base leading-[1.625] text-on-brand/75">
          {description}
        </p>
      </div>
    </section>
  );
}
